<div
	[(ngbCollapse)]="isOnline"
	class="tw:flex tw:items-center tw:justify-center tw:bg-red-400 tw:p-2 tw:fixed tw:top-0 tw:left-0 tw:right-0 tw:font-medium tw:text-white"
	style="z-index: 1000"
>
	<mat-icon class="tw:me-2">info</mat-icon> You're offline
</div>
